import { createSelector } from '@ngrx/store';

import * as fromCore from '@web/core/selectors';
import { getRouteData } from '@web/core/reducers/router';
import { VIEdgeLiveRoutingMap } from '@live/routes/live-edge-routes.config';

import * as fromPresets from './live-presets.selectors';
import * as fromCameras from './live-cameras.selectors';

export const getExtensionDetailsDialogData = createSelector(
  fromCore.isLiveModuleLoaded,
  fromCore.selectedEdgeExtension,
  fromCore.selectedEdgeExtensionTotalIndexedMinutes,
  fromPresets.selectTotalNumberOfPresets,
  fromCameras.selectTotalNumberOfCameras,
  fromCore.getTenantId,
  fromCore.isLiveStreamEnabled,
  fromCore.isMediaUploadsEnabled,
  fromCore.isSearchWithRAGEnabled,
  (
    isLiveModuleLoaded,
    extension,
    totalIndexedMinutes,
    numberOfPresets,
    numberOfCameras,
    tenantId,
    isLiveStreamEnabled,
    isMediaUploadsEnabled,
    isSearchWithRAGEnabled
  ) => {
    if (!isLiveModuleLoaded) {
      return null;
    }

    return {
      tenantId,
      totalIndexedMinutes,
      createdAt: extension?.systemData.createdAt,
      numberOfPresets,
      numberOfCameras,
      version: extension?.properties.version,
      extensionResourceId: extension?.id,
      // When media files upload is disabled - we still showing up the media files tab
      // But it will have the camera's saved recording files only.
      mediaUploadsEnabled: isMediaUploadsEnabled,
      liveEnabled: isLiveStreamEnabled,
      searchWithRAGEnabled: isSearchWithRAGEnabled
      // @TODO: implement after contract with BE is signed
      // aioResourceId:
    };
  }
);

export const getExtensionName = createSelector(fromCore.selectedEdgeExtensionName, extensionName => extensionName);

export const isLiveGalleryRoute = createSelector(
  getRouteData,
  state =>
    state?.path === VIEdgeLiveRoutingMap.cameras.path ||
    state?.path === VIEdgeLiveRoutingMap.mediaFiles.path ||
    state?.path === VIEdgeLiveRoutingMap.cameraManagement.path ||
    state?.path === VIEdgeLiveRoutingMap.alertRules.path
);
